module.exports = __webpack_public_path__ + "img/manager.6c0f4c3a.jpg";